module.exports = __webpack_public_path__ + "img/log4.d050e82b.png";